// Generated by CoffeeScript 1.11.1
var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

define('sp/ui/questions/question_forms/range',['require','./scale','../question_form','sp/utilities/restrict_numeric'],function(require) {
  var QuestionForm, Range, Scale, restrictNumeric;
  Scale = require('./scale');
  QuestionForm = require('../question_form');
  restrictNumeric = require('sp/utilities/restrict_numeric');
  return Range = (function(superClass) {
    extend(Range, superClass);

    function Range() {
      this.maxInputKeyupHandler = bind(this.maxInputKeyupHandler, this);
      this.maxInputChangeHandler = bind(this.maxInputChangeHandler, this);
      return Range.__super__.constructor.apply(this, arguments);
    }

    Range.prototype.range = true;

    Range.prototype.initialize = function(options) {
      Range.__super__.initialize.call(this, options);
      return this.range = true;
    };

    Range.prototype.render = function() {
      var $maxLabel, fromLabel, toLabel;
      Range.__super__.render.call(this);
      fromLabel = this.definitions.rangeMin || "To";
      toLabel = this.definitions.rangeMax || "From";
      this.$el.find('.min-value-label').text(fromLabel);
      $maxLabel = $("<label>").attr({
        "for": "max-value[" + (this.model.get('_id')) + "]",
        "class": "max-value-label"
      }).text(toLabel);
      this.$maxInput = $("<input>").appendTo(this.$el).attr({
        type: "text",
        id: "max-value[" + (this.model.get('_id')) + "]",
        name: "max-value[" + (this.model.get('_id')) + "]",
        "class": "max-value"
      }).keypress(restrictNumeric).keyup(this.maxInputKeyupHandler).change(this.maxInputChangeHandler);
      $('<li>').addClass('max-value-container').append([$maxLabel, this.$maxInput]).appendTo(this.el);
      return this.$el;
    };

    Range.prototype.maxInputChangeHandler = function(e) {
      if (Number(e.target.value) > Number(this.model.get("properties").max)) {
        e.target.value = this.model.get("properties").max;
      }
      if (Number(e.target.value) < Number(this.model.get("properties").min)) {
        e.target.value = this.model.get("properties").min + 1;
      }
      this.values[1] = e.target.value;
      return this.setValues(this.values);
    };

    Range.prototype.maxInputKeyupHandler = function(e) {
      var maxVal, minVal;
      minVal = Number(this.$minInput.val() || Number(this.model.get("properties").min));
      maxVal = Number(e.target.value);
      return this.setValues([minVal, maxVal]);
    };

    Range.prototype.setValues = function(vals) {
      if ($.isNumeric(vals[0])) {
        this.values[0] = Number(vals[0]);
        this.$minInput.val(Number(this.values[0]));
      }
      if ($.isNumeric(vals[1])) {
        this.values[1] = Number(vals[1]);
        this.$maxInput.val(Number(this.values[1]));
      }
      this.$slider[0].noUiSlider.set(this.values);
      return this.trigger(QuestionForm.UPDATE_EVENT, this);
    };

    return Range;

  })(Scale);
});

